<template>
  <div>
    <div class="smartkey"
      :style="setDetailStyle(itemData.column[0].detail)">
      <GetKey />
    </div>
    <Remotekey v-if="isRemotekey && useRemoteOpen"
      class="remotekey"
      :img="remotekeyImg"
      :style="setDetailStyle(itemData.column[1].detail)" />
  </div>
</template>

<script>
import GetKey from '@/components/Mobilekey/GetKey'
import Remotekey from '@/components/Mobilekey/RemoteKey'

export default {
  name: 'Smartkey',
  props: [
    'locale',
    'itemData'
  ],
  components: {
    GetKey,
    Remotekey
  },
  computed: {
    getMobilekeyInfo () {
      return this.$store.getters['guest/getMobilekeyInfo']
    },
    isRemotekey () {
      const getMobilekeyInfo = this.getMobilekeyInfo
      const detail = this.itemData.column[0].detail
      return getMobilekeyInfo && detail.smartkey && detail.smartkey.remotekey
    },
    useRemoteOpen () {
      return this.$store.getters['guest/getUseRemotekey']
    },
    remotekeyImg () {
      return this.isRemotekey && (this.itemData.column[1].detail.remotekey.img || '')
    }
  },
  watch: {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'background':
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'radius':
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
        if (x === 'smartkey') {
          styleObj['font-size'] = `${obj.size}px`
          styleObj['text-align'] = `${obj.align}`
        }
        if (x === 'remotekey') {
          styleObj['margin-top'] = `${obj.margin}px`
          styleObj['max-width'] = obj.size !== '100' ? `${obj.size}%` : 'none'
        }
      })
      return styleObj
    }
  }
}
</script>
